import $ from 'jquery';
import 'slick-carousel';

$('.goods__slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    rtl: true,
    centerPadding: '0',
    responsive: [
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                centerMode: true,
                rtl: true,
                centerPadding: '0',
            }
        },
        {
            breakpoint: 810,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                centerMode: true,
                rtl: true,
                centerPadding: '0',
            }
        },
        {
            breakpoint: 780,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                centerMode: true,
                rtl: true,
                centerPadding: '0',
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                centerMode: true,
                rtl: true,
                centerPadding: '0',
            }
        },
    ]
})

$('.testimonials__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: false,
    rtl: true,
})